import { render, staticRenderFns } from "./SystemSettingsCard.vue?vue&type=template&id=6d69ce76&scoped=true"
import script from "./SystemSettingsCard.vue?vue&type=script&lang=js"
export * from "./SystemSettingsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d69ce76",
  null
  
)

export default component.exports